export const PaymentSummaryCard = ({
  title,
  primaryValue,
  secondaryText,
  badge,
  dueAmount,
  largeValue,
  metaOnTop,
}) => (
  <div className="col">
    <div className="card dash-cards">
      <div className="card-body d-flex flex-column">
        <div className="d-flex align-items-start justify-content-between gap-2 mb-3">
          <span
            className="fw-medium mb-0"
            style={{ fontSize: "1.35rem", lineHeight: 1.3 }}
          >
            {title}
          </span>
          {badge ? (
            <span
              className={`badge ${badge.className} fw-normal rounded-pill px-3 flex-shrink-0`}
            >
              {badge.label}
            </span>
          ) : null}
        </div>
        {metaOnTop && secondaryText ? (
          <p className="mb-2" style={{ fontSize: "1.2rem", opacity: 0.85 }}>
            {secondaryText}
          </p>
        ) : null}
        <h3
          className="fw-bold mb-0"
          style={{ fontSize: largeValue ? "1.8rem" : "1.8rem", lineHeight: 1.2 }}
        >
          {primaryValue}
        </h3>
        {dueAmount ? (
          <p
            className="fw-semibold mb-0 mt-2"
            style={{ fontSize: "1.65rem", lineHeight: 1.3 }}
          >
            Due {dueAmount}
          </p>
        ) : null}
        {!metaOnTop && secondaryText ? (
          <p className="mb-0 mt-auto" style={{ fontSize: "1.2rem" }}>
            {secondaryText}
          </p>
        ) : null}
      </div>
    </div>
  </div>
);